var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$parent.token ? 'active' : '', 'py-5'],attrs:{"id":"content-dash"}},[_c('div',{staticClass:"container"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }